import React, { useState, useEffect } from 'react'
import './dashboard.css'
import './common.css'
import API_URL from '../common/Apiurl';
import Loader from "react-js-loader";
import { Link, NavLink, useNavigate } from "react-router-dom";

function  Dashboard(){
    const apiUrl = API_URL;
    const [items, setItems]=useState('');
    const [isLoading, setIsloading] = useState(false)
    useEffect(() => {
        const getValues = async() =>{
            setIsloading(true)
            try{
                const result = await fetch(`${apiUrl}/admin/dashboard`,{
                    method: 'POST',
                    headers: {
                        "Content-Type":"application/json",
                        "Accept":"application/json"
                    },
                });
                const data = await result.json();
                setItems(data.data);
                setIsloading(false)
            }
            catch(error){
                console.log('Error: ', error)
            }
        }
        getValues();
    },[]);
    return (
        <>
            <div className='width90'>
                <h2 className='pageTitle mt-4 mx-3'>Dashboard</h2>
                {isLoading ? <Loader type="spinner-cub" title={"loading....."} size={100} />:
                <div className="container mt-1 display-block">
                    {/* first row */}
                    <div className="row">
                        <div className="col-sm-4 mt-4">
                        <NavLink to="/admin/industry">
                            <div className="card">
                                <div className="container heightauto display-block padding30">
                                    <h4><b>Total Industry</b></h4> 
                                    <span className='calculation'>{items.industry}</span>
                                </div>
                            </div>
                            </NavLink>
                        </div>
              
                        <div className="col-sm-4 mt-4">
                            <NavLink to="/admin/category">
                            <div className="card cardsecond">
                                <div className="container heightauto display-block padding30">
                                    <h4><b>Total Category</b></h4> 
                                    <span className='calculation'>{items.category}</span>
                                </div>
                            </div>
                            </NavLink>
                        </div>
                        <div className="col-sm-4 mt-4">
                            <NavLink to="/admin/subcategory">
                            <div className="card cardthird">
                                <div className="container heightauto display-block padding30">
                                    <h4><b>Total Subcategory</b></h4> 
                                    <span className='calculation'>{items.subcategory}</span>
                                </div>
                            </div>
                            </NavLink>
                        </div>
                    </div>
                    {/* second row */}
                    <div className="row">
                        <div className="col-sm-4 mt-4">
                            <NavLink to="/admin/homeowner">
                            <div className="card cardsecond">
                                <div className="container heightauto display-block padding30">
                                    <h4><b>Total Homeowners</b></h4> 
                                    <span className='calculation'>{items.homeowners}</span>
                                </div>
                            </div>
                            </NavLink>
                        </div>
                        <div className="col-sm-4 mt-4">
                            <NavLink to="/admin/employers">
                            <div className="card cardthird">
                                <div className="container heightauto display-block padding30">
                                    <h4><b>Total Employers</b></h4> 
                                    <span className='calculation'>{items.employers}</span>
                                </div>
                            </div>
                            </NavLink>
                        </div>
                        <div className="col-sm-4 mt-4">
                            <NavLink to="/admin/provider">
                            <div className="card">
                                <div className="container heightauto display-block padding30">
                                    <h4><b>Total Providers</b></h4> 
                                    <span className='calculation'>{items.providers}</span>
                                </div>
                            </div>
                            </NavLink>
                        </div>
                    </div>
                    {/* third row */}
                    <div className="row">
                        <div className="col-sm-4 mt-4">
                            <NavLink to="/admin/alljobs">
                            <div className="card">
                                <div className="container heightauto display-block padding30">
                                    <h4><b>Total Jobs</b></h4> 
                                    <span className='calculation'>{items.job}</span>
                                </div>
                            </div>
                            </NavLink>
                        </div>
                    </div>
                </div>}
            </div>
        </>
    )
}

export default Dashboard;